import React, {PureComponent, View} from "react";
import PropTypes from 'prop-types';

import controllable from 'react-controllables';
//import shouldPureComponentUpdate from 'react-pure-render/function';
import { API, Storage } from "aws-amplify";
//import { FormGroup, FormControl, ControlLabel, ListGroup, ListGroupItem, Breadcrumb } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
//import LoaderButton from "../components/LoaderButton";
//import config from "../config";
import "./Trip.css";
import pako from "pako";
//import { s3Upload } from "../libs/awsLib";
import GoogleMapReact from 'google-map-react';
import MyGreatPlaceWithControllableHover from './my_great_place_with_controllable_hover.js';
//import 'html-hint/dist/html-hint.min.css';
import {K_SIZE} from './my_great_place_with_controllable_hover_styles.js';


//import ReactScrollableList from "react-scrollable-list";


import cameraIcon from'../images/camera.png';
import audioIcon from'../images/audio.png';
import selectIcon from'../images/selector.png';
import optionIcon from'../images/options.png';
import textIcon from'../images/text_entry.png';
import measureIcon from'../images/measurment.png';
import endIcon from'../images/end.png';
import recordingIcon from'../images/recording.png';
import photoIcon from'../images/photo.png';
import startIcon from'../images/start.png';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Icon from '@material-ui/core/Icon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
//import Checkbox from '@material-ui/core/Checkbox';
//import Avatar from '@material-ui/core/Avatar';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import CheckIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import StopIcon from '@material-ui/icons/Stop';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';


//import SkipPreviousIcon from '@material-ui/core/icons/SkipPrevious';
//import PlayArrowIcon from '@material-ui/icons/PlayArrow';
//import SkipNextIcon from '@material-ui/icons/SkipNext';
//import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import Button from '@material-ui/core/Button';

//import Lightbox from "react-image-lightbox";

//import List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction from '@material-ui/core/List';

//import Popup from "reactjs-popup";


import JSZip from 'jszip';
import FileSaver from 'file-saver';

//import MediaControlCard from './MediaControlCard.js';

//import { PlayButton, Timer } from 'react-soundplayer/components';
//import { withCustomAudio } from 'react-soundplayer/addons';

import Sound from 'react-sound';

import TripCard from "./TripCard";

import loaderIcon from'../images/ftc_logo.gif';
import Paper from '@material-ui/core/Paper';



const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

function Transition(props) {
  return <Slide direction="left" {...props} />;
}

/*
const AWSSoundPlayer = withCustomAudio(props => {
  const { trackTitle } = props;

  return (
    <div>
      <PlayButton {...this.props} />
      <Timer {...this.props} />
    </div>
  );
});
*/

/*
const images = [
  "//placekitten.com/1500/500",
  "//placekitten.com/4000/3000",
  "//placekitten.com/800/1200",
  "//placekitten.com/1500/1500"
];
*/
controllable(['center', 'zoom', 'hoverKey', 'clickKey'])


//import MarkerExample, {K_SCALE_NORMAL} from './TripMarker.js';

/*
import { GoogleApiWrapper, InfoWindow, Map, Marker, Polyline } from 'google-maps-react';
import Paper from 'material-ui/Paper';
//import Typography from 'material-ui/Typography';
import Typography from '@material-ui/core/Typography';
import { typography } from 'material-ui/styles';
*/



/*
const AnyReactComponent = ({ text }) => (
  <div style={{
    color: 'white',
    background: 'rgba(50,150,50,0.5)',
    padding: '15px 10px',
    display: 'inline-flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    transform: 'translate(-50%, -50%)'
  }}>
    {text}
  </div>
);
*/
/*
const StartPoint = ({ text }) => (
<div style={{
    color: 'white',
    background: 'rgba(150,50,50,1.0)',
    padding: '2px 2px',
    height: '12px',
    width: '12px',
    display: 'inline-flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    transform: 'translate(-50%, -50%)'
  }}>{text}

</div>

);
*/
/*
const EndPoint = ({ text }) => (
  <div style={{
    color: 'white',
    background: 'rgba(150,50,50,1.0)',
    padding: '2px 2px',
    height: '12px',
    width: '12px',
    display: 'inline-flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    transform: 'translate(-50%, -50%)'
  }}>
    {text}
  </div>
);
*/
function distance(lat1, lon1, lat2, lon2, unit) {
	var radlat1 = Math.PI * lat1/180
	var radlat2 = Math.PI * lat2/180
	var theta = lon1-lon2
	var radtheta = Math.PI * theta/180
	var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
	if (dist > 1) {
		dist = 1;
	}
	dist = Math.acos(dist)
	dist = dist * 180/Math.PI
	dist = dist * 60 * 1.1515
	if (unit=="K") { dist = dist * 1.609344 }
	if (unit=="N") { dist = dist * 0.8684 }
	return dist
}


export default class Trip extends PureComponent {



  static propTypes = {
    //center: PropTypes.array, // @controllable
    zoom: PropTypes.number, // @controllable
    hoverKey: PropTypes.string, // @controllable
    clickKey: PropTypes.string, // @controllable
    onCenterChange: PropTypes.func, // @controllable generated fn
    onZoomChange: PropTypes.func, // @controllable generated fn
    onHoverKeyChange: PropTypes.func, // @controllable generated fn

    greatPlaces: PropTypes.array
  };

    static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33
    },
    zoom: 18
  };

  //shouldComponentUpdate = shouldPureComponentUpdate;
  constructor(props) {
    super(props);
    //const orgId = this.props.org.pk;
    console.log(this.props);
    const projectId = this.props.location.state && this.props.location.state.projectId;
    const projectTitle = this.props.location.state && this.props.location.state.projectTitle;
    const schemaId = this.props.location.state && this.props.location.state.schemaId;
    const tripId = this.props.location.state && this.props.location.state.tripId;
    const projectLogo = this.props.location.state && this.props.location.state.logo;
    const version = this.props.location.state && this.props.location.state.version;
    const notes = this.props.location.state && this.props.location.state.notes;



//console.log(title);

    this.myRef = React.createRef();
    //console.log('XXXX');
    //console.log(this.props);

    this.file = null;
    this.state = {
      projectTitle: projectTitle,
      projectId: projectId,
      schemaId: schemaId,
      projectLogo: projectLogo,
      version: version,
      notes: notes,
      tripId: tripId,
      photoIndex: 0,
      isLightBoxOpen: false,

      audioIsPlaying: false,


      markerZOrder: 0,
      //showingInfoWindow: false,
      //activeMarker: {},
      //selectedPlace: {},

      checked: [1],

      isLoading: true,
      isDeleting: false,
      isDownloading: false,
      trip: null,
      title: "",
      logo: "",
      attachmentURL: null,
      description: "",
      downloaded: false
    };


        // binding this to event-handler functions
    //this.onMarkerClick = this.onMarkerClick.bind(this);
    //this.onMapClick = this.onMapClick.bind(this);

  }

  async componentDidMount() {
  if (!this.props.isAuthenticated) {
    return;
  }
  var orgId = this.props.user.pk;
  if (this.props.org) {
    orgId = this.props.org.pk;
  }
  let projectId = this.state.projectId;
  let tripId = this.state.tripId;
  let path = `${orgId}/trips/${tripId}/json/${tripId}.trp`;
  //console.log(pathx);
  console.log(path);
  Storage.get(path)
  .then(result => this.extractJson(result))
  .catch(err => console.log('ERR: ' + err));

/*
  try {
    let attachmentURL;

      this.setState({
        project,
        schemas: schemas,
        title: title,
        logo: logo,
        attachmentURL,
        description: description,
        active: active
      });


  } catch (e) {
    alert(e);
  }
*/
}
onHoverKeyChange = function(key) {
  //console.log('FUCK ME!');
}
extractJson(compressedJson) {
  let context = this;
  var xhr = new XMLHttpRequest();
  xhr.open("GET", compressedJson, true);
  xhr.onload = function()
  {
        let binaryString = xhr.response;
        let deflatedBinaryString = window.atob(binaryString);
        let jsonString = pako.inflate(deflatedBinaryString, { to: 'string' });
        console.log(jsonString);
        let obj = JSON.parse(jsonString);
        let t = obj.trip;
          context.setState({
            trip: t,
            json: jsonString
          });
        console.log(context.state.trip.installation_code);
                context.dosummit();

  }
  xhr.send();
}
dosummit() {
  console.log(this.state.trip.installation_code);

  let wps = this.state.trip.waypoints;
  let lat = 0;
  let lon = 0;
  let elat = 0;
  let elon = 0;
  if (wps.length > 0) {
    lat = wps[0].lat;
    lon = wps[0].lon;
    elat = wps[wps.length-1].lat;
    elon = wps[wps.length-1].lon;
  }
  this.setState({
            center: {
              lat: lat,
              lng: lon
            },
            end: {lat: elat, lng: elon}
          });
  //this.populateImagePaths(0);
  this.currentEventIndex = 0;
  this.populateFilePaths();

}
validateForm() {
  return this.state.title.length > 0;
}

formatFilename(str) {
  return str.replace(/^\w+-/, "");
}

handleChange = event => {
  this.setState({
    [event.target.id]: event.target.value
  });
}

handleFileChange = event => {
  this.file = event.target.files[0];
}

/*
saveProject(project) {
  if (this.props.org) {
    return API.put("ftc", `/organisations/${this.props.org.pk}/projects/${this.props.match.params.id}`, {body: project});
  } else {
    return API.put("ftc", `/organisations/user/projects/${this.props.match.params.id}`, {body: project});
  }
}
*/
handleSubmit = async event => {
  let attachment;

  event.preventDefault();

}

handleDownloadClick = event => {
  event.preventDefault();
  if (this.state.downloaded || this.state.downloading) {
    return;
  }
  this.setState({
    isDownloading: true,
  });
  this.updateTrip();
  this.currentEventIndex = 0;
  this.tripzip = new JSZip();
  this.tripzip.file("trip.json", this.state.json);
  this.getFilesAsBlobs();
}

getFilesAsBlobs() {
  let idx = this.currentEventIndex;
  if ( idx <this.state.trip.events.length) {
    console.log("WTFFFFFFx");
    if (this.state.trip.events[idx].imagePath != null) {

      console.log("WTFFFFFF");
      console.log(this.state.trip.events[idx].imagePath);
      this.getFileAsBlob("image/jpeg", this.state.trip.events[idx].imagePath);
    } else if (this.state.trip.events[idx].audioPath != null) {
      this.getFileAsBlob("audio/mp4", this.state.trip.events[idx].audioPath);
    } else {
      this.currentEventIndex = idx + 1;
      this.getFilesAsBlobs();
    }
  } else {
    this.saveTripZip();
  }

}
saveTripZip() {
  //let context = this;
  let tripId = this.state.tripId; //this.props.match.params.id2
  this.tripzip.generateAsync({type:"blob"})
  .then(function(content) {
      FileSaver.saveAs(content, tripId + ".zip");
  });
  this.setState({
    downloaded: true,
    isDownloading: false
  });

}



getFileAsBlob(mimeType, url) {
  console.log(url);
  let urlWithDummy = url + "&x-request=dummy"; //workaround to load in html and using get
  let context = this;
  var xhr = new XMLHttpRequest();
  xhr.open("GET", urlWithDummy, true);
  xhr.responseType = "arraybuffer";
  xhr.onload = function(e)
  {
        var arrayBufferView = new Uint8Array( this.response );
        var blob = new Blob( [ arrayBufferView ], { type: mimeType } );
        context.addFileToZip(blob);
  }
  xhr.send();
}
addFileToZip(blob) {
  let idx = this.currentEventIndex;
  if (this.state.trip.events[idx].imagePath != null) {
    var folder = this.tripzip.folder("images");
  } else if (this.state.trip.events[idx].audioPath != null) {
    var folder = this.tripzip.folder("audio");
  }
  var filename = '';
  if (this.state.trip.events[idx].type === 'PHOTO') {
    filename = this.state.trip.events[idx].values.image;
  } else {
    filename = this.state.trip.events[idx].values.filename;
  }
  //var filename = this.state.trip.events[idx].values.filename;
  folder.file(filename, blob);
  this.currentEventIndex = idx + 1;
  this.getFilesAsBlobs();
}




updateTrip() {
  const ids = ['TRP|' + this.state.projectId + '|' + this.state.schemaId + '|' + this.state.tripId];
  let orgId = 'user';
  if (this.props.org) {
    orgId = this.props.org.pk;
  }
  const body = {orgId: orgId, ids: ids};
  //console.log(body);
  try {
    return API.put("ftc", "/trips", {body: body});
  }catch(e) {
    console.log(e);
  }
}



handleCrumbClick = event => {
  event.preventDefault();
  const href = event.currentTarget.getAttribute("href");
  if (href === "/Projects/Project") {
    this.props.history.push({
      pathname: '/projects/project',
      state: { projectId: this.state.projectId }
    });
  } else if (href === "/Projects/Project/Trips") {
    this.props.history.push({
      pathname: '/projects/schemas/trips',
      state: { projectId: this.state.projectId, projectTitle: this.state.projectTitle, version: this.state.version, logo: this.state.projectLogo, notes: this.state.notes, schemaId: this.state.schemaId, title: this.state.bcTitle}
    });
  } else {
    this.props.history.push(href);
  }
  //this.props.history.push(event.currentTarget.getAttribute("href"));
}
handleEventClick = event => {
  event.preventDefault();
  //this.props.history.push(event.currentTarget.getAttribute("href"));
}
handleToggle = value => () => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });
  };

handleGoogleMapApi = (google) => {
  var path = [];
  let wps = this.state.trip.waypoints;
  for(var i = 0; i < wps.length; i++) {
      var wp = wps[i];
      path.push({ "lat": wp.lat, "lng": wp.lon });
      //console.log(wp.lat + ' ' + wp.lon);
  }



      var flightPath = new google.maps.Polyline({
        //path: [ { "lat": 53.480759, "lng": -2.242631 },{ "lat": 51.507351, "lng": -0.127758 },{ "lat": 55.953252, "lng": -3.188267 } ],
        path: path,
        geodesic: true,
        strokeColor: '#33BD4E',
        strokeOpacity: 1,
        strokeWeight: 2
      });

      flightPath.setMap(google.map);
    }


    _onBoundsChange = (center, zoom ) => {
      console.log('_onBoundsChange');
    this.props.onCenterChange(center);
    this.props.onZoomChange(zoom);
  }

  _onChildClick = (key, childProps) => {
     if (key != this.state.currentKey) {
      this.setState({
        audioPosition: 0,
        currentKey: key
      });
  }

    //childProps.hover = true;
    //this.props.onCenterChange([childProps.lat, childProps.lng]);
  }

  _onChildMouseEnter = (key ) => {
    //console.log('KEY:' + key);
    //this.props.onHoverKeyChange(key);
    //this.props.hover = false;






  }

  _onChildMouseLeave = () => {
    //this.props.onHoverKeyChange(null);
  }

populateFilePaths() {
  let idx = this.currentEventIndex;
  var orgId = this.props.user.pk;
  if (this.props.org) {
    orgId = this.props.org.pk;
  }

  let projectId = this.state.projectId; //this.props.match.params.id
  let tripId = this.state.tripId; //this.props.match.params.id2
  if (idx < this.state.trip.events.length) {
    if (this.state.trip.events[idx].type === 'PHOTO') {
      let filename = this.state.trip.events[idx].values.image;
      let path = `${orgId}/trips/${tripId}/photos/${filename}`;
      Storage.get(path)
        .then(result => this.addAuthenticatedFilePath(result))
        .catch(err => console.log('ERR: ' + err));
    } else if (this.state.trip.events[idx].type === 'RECORDING') {
      let filename = this.state.trip.events[idx].values.filename;
      let path = `${orgId}/trips/${tripId}/audio/${filename}`;
      Storage.get(path)
        .then(result => this.addAuthenticatedFilePath(result))
        .catch(err => console.log('ERR: ' + err));
    } else {
      this.currentEventIndex = idx + 1;
      this.populateFilePaths();
    }
  } else {
    this.setState({
      isLoading: false,
    });
  }
}

addAuthenticatedFilePath(path) {
  let idx = this.currentEventIndex;
  if (this.state.trip.events[idx].type === 'PHOTO') {
    this.state.trip.events[idx].imagePath = path;
  } else if (this.state.trip.events[idx].type === 'RECORDING') {
    this.state.trip.events[idx].audioPath = path;
  }
  this.currentEventIndex = idx + 1;
  this.populateFilePaths();
}




getMapOptions = (maps: Maps) => {

    return {
        streetViewControl: false,
        scaleControl: true,
        fullscreenControl: false,
        styles: [{
            featureType: "poi.business",
            elementType: "labels",
            stylers: [{
                visibility: "off"
            }]
        }],
        gestureHandling: "greedy",
        disableDoubleClickZoom: true,
        minZoom: 8,
        maxZoom: 25,

        mapTypeControl: true,
        mapTypeId: maps.MapTypeId.SATELLITE,
        mapTypeControlOptions: {
            style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: maps.ControlPosition.TOP_LEFT,
            mapTypeIds: [
                maps.MapTypeId.ROADMAP,
                maps.MapTypeId.SATELLITE,
                maps.MapTypeId.HYBRID
            ]
        },

        zoomControl: true,
        clickableIcons: false
    };
}



renderMap() {
/*
    const style = {
      width: '50vw',
      height: '75vh',
      'marginLeft': 'auto',
      'marginRight': 'auto'
    }
*/

  //let wps = this.state.trip.waypoints;
  let evts = this.state.trip.events;
  //let tick = Math.floor(wps.length / evts.length);
  //var markers = [];
  //var xxx = [];
  var evtslist = [];

  for(var i = 0; i < evts.length; i++) {
      var e = evts[i];
      //let lat = wps[i*tick].lat;
      //let lon = wps[i*tick].lon;
      //console.log(e.type);
      //markers.push(<StartPoint lat={lat} lng={lon} key={i} text={'s'} />) ;
      evtslist.push({id: e.id.toString(), type: e.type, lat: e.lat, lng: e.lon, title: e.title});
  }

      const places = evtslist
      .map(place => {
        const {id, type, title, ...coords} = place;

        return (
          <MyGreatPlaceWithControllableHover
            key={id}
            {...coords}
            text={id}
            type={type}
            title={title}
            // use your hover state (from store, react-controllables etc...)
            //hover={this.props.hoverKey === id}
            hover={this.state.currentKey == id}
            />
        );
      });

  //{markers}
  //console.log(markers);
    return (

          <div className="trip_map">
            <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyAirpQjNBpOf2C2NPVoAKkotBlO_ZfUXNI' }}
              options={this.getMapOptions}
              defaultCenter={this.state.end}
              defaultZoom={this.props.zoom}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={this.handleGoogleMapApi}
        hoverDistance={K_SIZE / 2}
        //onBoundsChange={this._onBoundsChange}
                      onChildClick={this._onChildClick}
        onChildMouseEnter={this._onChildMouseEnter}
        onChildMouseLeave={this._onChildMouseLeave}

            >
              {places}
            </GoogleMapReact>
          </div>



/*
      <Map
        item
        xs = { 12 }
        style = { style }
        google = { this.props.google }
        onClick = { this.onMapClick }
        zoom = { 14 }
        initialCenter = {yyy[0]}
      >
        <Marker
          onClick = { this.onMarkerClick }
          //onMouseover={this.onMouseoverMarker}
          title = { 'Changing Colors Garage' }
          position = {{ lat: 39.648209, lng: -75.711185 }}
          name = { 'Changing Colors Garage' }
          id = {'111'}
        />
        <InfoWindow
          marker = { this.state.activeMarker }
          visible = { this.state.showingInfoWindow }
        >



        <div>jhfkhfk</div>




        </InfoWindow>
      </Map>
      */
    );

  }



handleClick = (key) => {
    console.log(key);
    if (key != this.state.currentKey) {
      this.setState({
        audioPosition: 0,
        currentKey: key
      });
  }
  };
handleImageClick = (evt) => {
  //event.stopPropagation();
  //console.log(event);
    //this.setState({ [e]: !this.state[e] });
    //event.stopPropagation();
    console.log('handleImageClick: ' + evt);
    this.setState({
      currentKey: evt.id,
      isLightBoxOpen: true,
      currentEvent: evt
    });

  };
handleViewClick = (evt) => {
    this.setState({
      currentKey: evt.id,
      isLightBoxOpen: true,
      currentEvent: evt
    });

  };

handlePlayPauseClick = (key) => {
  //event.preventDefault();
  let isPlaying = this.state.audioIsPlaying;
  console.log(isPlaying, key, this.state.currentKey);
  if (key == this.state.currentKey) {
    this.setState({
      audioIsPlaying: !isPlaying
    });

  } else {
    this.setState({
      currentKey: key,
      audioPosition: 0,
      audioIsPlaying: true
    });
  }
  };

  handleFinishedPlaying = () => {

    this.setState({
      audioIsPlaying: false
    });
  };
  handlePlaying = (player) => {
    //console.log('PLAYING: ', player.position, player.duration);
    this.setState({
      audioPosition: player.position,
      audioDuration: player.duration
    });
  };

  getIcon(type) {
    switch(type) {
      case 'START':
        return startIcon;
        case 'END':
          return endIcon;
          case 'AUDIO':
            return audioIcon;
      case 'RECORDING':
        return recordingIcon;
      case 'MEASUREMENT':
        return measureIcon;
      case 'CAMERA':
        return cameraIcon;
      case 'PHOTO':
        return photoIcon;
      case 'TEXTS':
        return textIcon;
      case 'SELECTORS':
        return selectIcon;
      case 'OPTIONS':
        return optionIcon;
    }
  }
  getShadedColour(type) {
    switch(type) {
      case 'START':
        return '#4AA46155';
      case 'END':
        return '#DB444055';
      case 'AUDIO':
        return '#9D578722';
      case 'RECORDING':
        return '#9D578722';
      case 'MEASUREMENT':
        return '#F8CC5C22';
      case 'CAMERA':
        return '#DB435C22';
      case 'PHOTO':
        return '#DB435C22';
      case 'TEXTS':
        return '#B0CC5C22';
      case 'SELECTORS':
        return '#E78B4822';
      case 'OPTIONS':
        return '#4097D422';
    }
  }
  getColour(type) {
    switch(type) {
      case 'START':
        return '#4AA461';
      case 'END':
        return '#DB4440';
      case 'AUDIO':
        return '#9D5787';
      case 'RECORDING':
        return '#9D5787';
      case 'MEASUREMENT':
        return '#F8CC5C';
      case 'CAMERA':
        return '#DB435C';
      case 'PHOTO':
        return '#DB435C';
      case 'TEXTS':
        return '#B0CC5C';
      case 'SELECTORS':
        return '#E78B48';
      case 'OPTIONS':
        return '#4097D4';
    }
  }
getTimeText(t1, t2) {
  const diff = t2-t1;
  var delta = diff / 1000;
  var days = Math.floor(delta / 86400);
  const daysStr = days > 0 ? days + 'd ' : ''
  delta -= days * 86400;
  var hours = Math.floor(delta / 3600) % 24;
  const hrsStr = hours > 0 ? hours + 'h ' : ''
  delta -= hours * 3600;
  var minutes = Math.floor(delta / 60) % 60;
  const minStr = minutes > 0 ? minutes + 'm ' : ''
  delta -= minutes * 60;
  var seconds = Math.ceil(delta % 60);
  const secStr = seconds + 's '
  const timeStr = daysStr + hrsStr + minStr + secStr;
  return timeStr;
}
getTimeDiffText(evts, idx) {
  const idx2 = idx + 1;
  if (idx2 == evts.length) {
    return '';
  } else {
    const t1 = evts[idx].timestamp;
    const t2 = evts[idx2].timestamp;
    return this.getTimeText(t1, t2);
  }
}

getDistanceText(evts, idx) {
  const idx2 = idx + 1;
  if (idx2 == evts.length) {
    return '';
  } else {
    const lat1 = evts[idx].lat;
    const lon1 = evts[idx].lon;
    const lat2 = evts[idx2].lat;
    const lon2 = evts[idx2].lon;
    const dist = Math.ceil(distance(lat1, lon1, lat2, lon2, 'K') * 1000);
    const distStr = dist + ' meter' + (dist == 1 ? '' : 's');
    return distStr;
  }

  //return "32' 67m";
}
  renderAudio(event) {
    //console.log(this.state.currentKey, event.id, this.state.audioIsPlaying);
    var pos = 0;
    if (this.state.audioIsPlaying) {
      pos = this.state.audioPosition/this.state.audioDuration*100
    }
    const colour = this.getColour(event.type);
    //console.log('POS: ', pos);

    return(
          <div >
           <Card style={{backgroundColor: colour, width: 60, height:60,display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
            <div >




                <IconButton aria-label="Play/pause" onClick={this.handlePlayPauseClick.bind(this, event.id)}>
            <CircularProgress
          variant="static"
          value={this.state.currentKey == event.id ? pos : 0}
        />
                 {this.state.currentKey == event.id && this.state.audioIsPlaying ? (<StopIcon style={{position: 'absolute'}} />) : (<PlayArrowIcon  style={{position: 'absolute'}} />)}
                </IconButton>




          <Typography variant="subheading" color="textSecondary">

          </Typography>

              </div>





    </Card>


    <Sound
       url={event.audioPath}
       playStatus={this.state.currentKey == event.id ? this.state.audioIsPlaying ? Sound.status.PLAYING : Sound.status.STOPPED : Sound.status.STOPPED}
       onLoading={this.handleLoading}
       onPlaying={this.handlePlaying}
       onFinishedPlaying={this.handleFinishedPlaying}
       />
    </div>

    )
  }
  renderImage(evt) {
    const colour = this.getColour(evt.type);
    return(
          <div >
           <Card style={{backgroundColor: colour, width: 60, height:60,display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
           <CardActionArea onClick={this.handleImageClick.bind(this, evt)}>
              <CardMedia
                component="img"
                style={{objectFit: 'cover'}}
                height="70"
                image={evt.imagePath}
              />
            </CardActionArea>
           </Card>
          </div>
        )
  }

renderMeasurement(evt) {
  console.log(evt.values)
  const colour = this.getColour(evt.type);

  let v = evt.values.value;
    return(
          <div >
           <Card style={{backgroundColor: colour, width: 60, height:60,display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
              <CardContent style={{padding: 0}}>
                <Typography style={{color: '#fff'}} variant="headline" component="h2" align='center'>
                  {v}
                </Typography>
                <Typography style={{color: '#fff'}} component="p" align='center'>
                  meters
                </Typography>
        </CardContent>
                   </Card>
          </div>
        )
  }
  renderCount(evt) {
    const colour = this.getColour(evt.type);
    let count = Object.keys(evt.values).length;
      return(
            <div >
             <Card style={{backgroundColor: colour, width: 60, height:60,display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
                <CardContent style={{padding: 0}}>
                  <Typography style={{color: '#fff'}} variant="headline" component="h2" align='center'>
                    {count}
                  </Typography>
                  <Typography style={{color: '#fff'}} component="p" align='center'>
                    {evt.type === 'CAMERA' ? 'pics' : 'recordings'}
                  </Typography>
          </CardContent>
                     </Card>
            </div>
          )
    }

renderSelector(evt) {
  //console.log(evt.values)
  const colour = this.getColour(evt.type);

  let v = evt.values.selected;
    return(
          <div >
           <Card style={{backgroundColor: colour, width: 60, height:60,display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
              <CardContent style={{padding: 2}}>
                <Typography style={{color: '#fff'}} variant="caption" component="p" align='center'>
                  {v}
                </Typography>
        </CardContent>
                   </Card>
          </div>
        )
  }

  renderViewValues(event) {
    const colour = this.getColour(event.type);

    return(
      <div >
        <Card style={{backgroundColor: colour, width: 60, height:60,display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
              <IconButton aria-label="Play/pause" onClick={this.handleViewClick.bind(this, event)}>
                <Typography variant="button" style={{color: '#fff'}}>
                  {event.type=='TEXTS' ? 'View Texts' : event.type=='OPTIONS' ? 'View Options' : ''}
                </Typography>
              </IconButton>
        </Card>
      </div>
    )
  }

  renderStart(evt) {
    //console.log(evt.values)
    const colour = this.getColour(evt.type);

    let v = evt.values.selected;
      return(
            <div >
            </div>
          )
    }
    renderEnd(evt) {
      //console.log(evt.values)
      const colour = this.getColour(evt.type);

      let v = evt.values.selected;
        return(
              <div >
              </div>
            )
      }


  renderBlank(event) {
    return(<div/>)
  }
  renderValues(evt) {
    switch(evt.type) {
      case 'START':
        return this.renderStart(evt);
      case 'END':
        return this.renderEnd(evt);
      case 'AUDIO':
        return this.renderCount(evt);
      case 'RECORDING':
        return this.renderAudio(evt);
      case 'CAMERA':
        return this.renderCount(evt);
      case 'PHOTO':
        return this.renderImage(evt);
      case 'MEASUREMENT':
        return this.renderMeasurement(evt);
      case 'TEXTS':
        return this.renderViewValues(evt);
      case 'SELECTORS':
        return this.renderSelector(evt);
      case 'OPTIONS':
        return this.renderViewValues(evt);
      default:
        return this.renderBlank(evt);
    }
  }
renderEventsList() {
  /*
  const styles = {
  selected: {
    color: 'green',
    background: 'red',
  },
}
*/
  let evts = this.state.trip.events;
  //console.log(evts[0]);
  //console.log(evts[evts.length-2]);
  //console.log(evts[evts.length-1]);
  return (
    <div className="scroller">
      <List style={{paddingTop: '0px', paddingLeft: '1px', paddingBottom: '0px', paddingRight: '1px', backgroundColor: '#fff'}}>
        {evts.map((evt, i) => (
          <div  key={'z' + i}>
          <ListItem key={i} dense divider button onClick={this.handleClick.bind(this, evt.id)}
            style={{height: '76px', paddingLeft: '8px', backgroundColor: this.state.currentKey == evt.id ? this.getColour(evt.type) : this.getShadedColour(evt.type)}}
          >
          <div>
            <img src={this.getIcon(evt.type)} width='24' height='24' style={{ position: 'absolute', top: '8px'}}/>
            <Typography variant="caption" style={{ position: 'absolute', bottom: '4px', right: evt.type === 'START' || evt.type === 'END' ? '8px' : '76px', color: this.state.currentKey == evt.id ? '#fff' : '#888', paddingLeft: '4px',paddingBottom: '0px',paddingTop: '0px', margin: '0px' }}>{(new Date(evt.timestamp)).toLocaleString()}</Typography>
          </div>

            <ListItemText style={{ position: 'absolute', top: '10px', left: '24px'}} primary={ evt.type === 'END' ? 'END' : evt.title} secondary={ evt.alias} />
            <div style={{position: 'absolute', right: '8px'}}>{this.renderValues(evt)}</div>
          </ListItem>
          { evts.length > (i + 1)  &&
          <ListItem key={'x' + i} dense divider
            style={{ height: '16px', backgroundColor: '#eee', padding: '0px', margin: '0px'}}
          >
          <ListItemText style={{ position: 'absolute', right: '4px', padding: '0px', margin: '0px'}} disableTypography
      primary={<Typography variant="caption" style={{ color: '#ccc', padding: '0px', margin: '0px' }}>{this.getTimeDiffText(evts, i)}</Typography>} />
      <ListItemText style={{ position: 'absolute', left: '4px', padding: '0px', margin: '0px'}} disableTypography
  primary={<Typography variant="caption" style={{ color: '#ccc', padding: '0px', margin: '0px' }}>{this.getDistanceText(evts, i)}</Typography>} />
            </ListItem>
          }
            </div>
        ))}
      </List>
    </div>
  );
}





handleClose = () => {
    this.setState({ isLightBoxOpen: false });
  };
renderViewValueOptionItem(value) {

  return(
  <div>
                    <ListItemText
                      primary={value.key}

                    />
                    <ListItemSecondaryAction>
                      <IconButton aria-label="Delete">
                        <CheckIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                    </div>
                    )

}
renderViewValueTextItem(value) {

  return(
                    <ListItemText primary={ value.key} secondary={ value.value} />
                    )

}
renderViewValueList(evt) {
  let vals = evt.values;
  let valsArr = [];
  for (var key in vals) {
    if (vals.hasOwnProperty(key)) {
        console.log(key + " -> " + vals[key]);
        valsArr.push({key: key, value: vals[key]});
    }
  }

  return(
  <List>
        {valsArr.map((value, i) => (
          <ListItem key={i} dense button onClick={this.handleClick.bind(this, value)}

          >
            {evt.type=='TEXTS' ? this.renderViewValueTextItem(value) : evt.type=='OPTIONS' ? this.renderViewValueOptionItem(value) : ''}


          </ListItem>
        ))}

</List>




  )
}

renderPopupDialog() {
  let evt = this.state.currentEvent;
  //let date = new Date(evt.timestamp);

  //console.log(date, this.state.currentKey, evt);
    return (
      <div>
        <Dialog
          open={this.state.isLightBoxOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {evt.title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
               {(new Date(evt.timestamp)).toLocaleString()}
            </DialogContentText>
            {evt.type=='PHOTO' && <img src={evt.imagePath} style={{maxWidth: 500, maxHeight:500}}/>}
            {(evt.type=='TEXTS' || evt.type=='OPTIONS') && this.renderViewValueList(evt)}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>




    );
  }
/*

{!this.state.isLoading && <TripCard
  title={this.state.bcTitle}
  description={'description here (maybe uploaded date, downloaded date and start end datyes of trip)'}
  logo={this.state.attachmentURL}
  active={false}
  onClick={this.handleActivateClick}
  colour={'#FAFcFA'}
  />}
   <div className="header">
     <img src={this.state.attachmentURL} alt="Project Logo"/>
     <h2>{this.state.title}
       <span className="pull-right">
       <button
       className="btn-download"
       onClick={this.handleDownloadClick}>
       Download
     </button>
       </span>
     </h2>
     <p>{this.state.description}</p>
     <div className="clear">
  <div className="trip_container">
   {!this.state.isLoading && this.renderMap()}
   <div className="trip_list_box">
     {!this.state.isLoading && this.renderEventsList()}
   </div>
 </div>



     </div>

   </div>






*/
  renderMain() {
    let gg = 'jjjj';
    const evts = this.state.trip.events;
    const t1 = evts[0].timestamp;
    const t2 = evts[evts.length-1].timestamp;
    console.log(this.state.trip.events);
    return(
      <div>




      <TripCard
        title={this.state.projectTitle + ': schema version ' + this.state.version}
        subtitle={'Trip: ' + this.state.tripId}
        description={'START: ' + (new Date(t1)).toLocaleString() + ' - END: ' + (new Date(t2)).toLocaleString() + ' - duration: ' + this.getTimeText(t1, t2)}
        logo={this.state.projectLogo}
        isDownloading={this.state.isDownloading}
        downloaded={this.state.downloaded}
        onClick={this.handleDownloadClick}
        colour={'#FAFcFA'}
        />
        <Paper style={{marginTop: '8px'}} elevation={1}>
           <div className="clear">
            <div className="trip_container">
              {this.renderMap()}
                <div className="trip_list_box">
                  {this.renderEventsList()}
                </div>
              </div>
            </div>
         </Paper>





      </div>
    )
  }

  renderLoader() {
    const label = this.state.isDownloading ? 'downloading...' : 'loading...';
    return(

      <div id="splash" style={{paddingTop: 250, zIndex:999}}>

        <center id="splash">
          <img src={loaderIcon}/>
          <Typography style={{padding: '4px'}} variant="caption">{label}</Typography>
        </center>
      </div>



    )
  }

render() {
  const { photoIndex, isLightBoxOpen } = this.state;
  //const bull = <span className={classes.bullet}>•</span>;
  return (
  <div>
    <Breadcrumb style={{top: 58, left: 66, right: 0, position: 'absolute', zIndex:999, backgroundColor: '#FFF'}}>
      <Breadcrumb.Item onClick={this.handleCrumbClick} href="/">Home</Breadcrumb.Item>
      <Breadcrumb.Item onClick={this.handleCrumbClick} href="/Projects">Projects</Breadcrumb.Item>
      <Breadcrumb.Item onClick={this.handleCrumbClick} href="/Projects/Project">{this.state.projectTitle + ': v' + this.state.version}</Breadcrumb.Item>
      <Breadcrumb.Item onClick={this.handleCrumbClick} href="/Projects/Project/Trips">Trips</Breadcrumb.Item>
      <Breadcrumb.Item active>{this.state.tripId}</Breadcrumb.Item>
    </Breadcrumb>
     <div className="Project"  style={{position: 'absolute', left:80, right:80,top: 104, paddingBottom:0}}>


      {this.state.isLoading ? this.renderLoader() : this.renderMain()}




        </div>
      {isLightBoxOpen && this.renderPopupDialog()}
    </div>
  );
}


}



// WEBPACK FOOTER //
// ./src/containers/Trip.js